(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ishba-capsules"] && !Shopify.designMode) return;
  try {
    /* ISHBA: Scoped Capsule Variant Refresh */

if (!customElements.get('ishba-product-capsules')) {

  class IshbaProductCapsules extends HTMLElement {

    constructor() {
      super();
      this.ishbaSequence = 0;
      this.onIshbaProductSelect =
        this.onIshbaProductSelect.bind(this);
    }

    connectedCallback() {
      this.ishbaScope = this.closest(
        'quick-add-dialog, product-information, featured-product-information, .shopify-section'
      );

      this.ishbaScope?.addEventListener(
        'shopify:product:select',
        this.onIshbaProductSelect
      );
    }

    disconnectedCallback() {
      this.ishbaScope?.removeEventListener(
        'shopify:product:select',
        this.onIshbaProductSelect
      );

      this.ishbaSequence++;
    }

    onIshbaProductSelect(event) {

      if (!(event.target instanceof Element) || !event.promise) {
        return;
      }

      const sourceScope = event.target.closest(
        'quick-add-dialog, product-information, featured-product-information, .shopify-section'
      );

      if (sourceScope !== this.ishbaScope) {
        return;
      }

      if (
        event.product?.id &&
        String(event.product.id) !== this.dataset.productId
      ) {
        return;
      }

      const sequence = ++this.ishbaSequence;

      event.promise.then((result) => {

        if (
          !this.isConnected ||
          sequence !== this.ishbaSequence
        ) {
          return;
        }

        const detail = result?.detail;
        if (!detail?.html) return;

        if (
          detail.productId &&
          String(detail.productId) !== this.dataset.productId &&
          !detail.newProduct
        ) {
          return;
        }

        const incoming = Array.from(
          detail.html.querySelectorAll(
            'ishba-product-capsules'
          )
        ).find(
          (element) =>
            element.dataset.ishbaBlockId ===
            this.dataset.ishbaBlockId
        );

        if (!incoming) return;

        /* Remove all whitespace when no capsules qualify. */
        if (!incoming.querySelector('.ishba-capsule')) {
          this.replaceChildren();
        } else {
          this.replaceChildren(
            ...Array.from(
              incoming.childNodes,
              (node) => node.cloneNode(true)
            )
          );
        }

        if (incoming.dataset.productId) {
          this.dataset.productId =
            incoming.dataset.productId;
        }

      }).catch((error) => {

        if (error?.name !== 'AbortError') {
          console.warn(
            '[ISHBA] Capsule update skipped:',
            error
          );
        }

      });
    }
  }

  customElements.define(
    'ishba-product-capsules',
    IshbaProductCapsules
  );
}

/* ISHBA: Scoped Capsule Variant Refresh END */
  } catch(e) { console.error(e); }
})();

})();
